export enum TABBED_CONTENT_TYPE {
    FOUR_COLUMN = "FOUR_COLUMN",
    TWO_THREE_COLUMN = "TWO_THREE_COLUMN",
}

type TabbedContentHeaderType = {
    title: string;
    description: string;
};

export type TabType = {
    title: string;
    content: any[];

    subtitle?: string;
};

export type TabbedContentStructure = {
    header: TabbedContentHeaderType[];
    tabs: TabType[];
    showMoreButtonLabel: string;

    rating?: 1 | 2 | 3 | 4 | 5;
    disclaimer?: string;
};

export interface TabbedContentProps {
    content: TabbedContentStructure;

    type?: TABBED_CONTENT_TYPE;
}
